<template>
  <!-- MENU CENTRAL -->
    <section class="d-none d-lg-block d-xl-block d-xxl-block">

        <div class="grid">
            <div class="row g-0">
                <div class="col-3">
                    <div class="item">
                        <img :src="`${publicPath}img/home00RocaGroup.jpg`" alt='' class="foto1">
                        <div aria-labelledby="columna1" class="hover">
                            <div class="item__overlay">
                                <div class="itemHeader" id="columna1" aria-hidden="true">
                                    <div class="row headerHome">
                                        <div class="col-9 pe-0"><h3 class="text-white"><localized-link to="/roca-group-2021">ROCA GROUP<br>2021</localized-link></h3></div>
                                        <div class="col-3 text-end itemNumber"></div>
                                    </div>
                                </div>
                                <div class="item__body">
                                    <ul class="navbar-nav">
                                      <li class="itemMenu">
                                        <localized-link to="/roca-group-2021/presentacion">{{ $t("nav.presentacion") }}</localized-link>
                                      </li>
                                        <li class="itemMenu">
                                            <localized-link to="/roca-group-2021/2021-en-resumen">{{ $t("nav.resumen") }}</localized-link>
                                        </li>
                                      <li class="itemMenu">
                                        <localized-link to="/roca-group-2021/roca-group-en-el-mundo">{{ $t("nav.en-el-mundo") }}</localized-link>
                                      </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="item">
                        <img :src="`${publicPath}img/home01avanzando.jpg`" alt='' class="foto2">
                        <div aria-labelledby="columna2" class="hover">
                            <div class="item__overlay">
                                <div class="itemHeader" id="columna2" aria-hidden="true">
                                    <div class="row headerHome">
                                        <div class="col-9 pe-0"><h3 class="text-white"><localized-link to="/avanzando-hacia-el-futuro" v-html="$t('home.moving')"></localized-link></h3></div>
                                        <div class="col-3 text-end itemNumber">01</div>
                                    </div>
                                </div>
                                <div class="item__body">
                                    <ul class="navbar-nav">
                                        <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/crecimiento">{{ $t("nav.crecimiento") }}</localized-link></li>
                                        <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional">{{ $t("nav.excelencia-operacional") }}</localized-link></li>
                                        <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/innovacion">{{ $t("nav.innovacion") }}</localized-link></li>
                                        <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/transformacion-digital">{{ $t("nav.transformacion-digital") }}</localized-link></li>
                                        <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/sostenibilidad">{{ $t("nav.sostenibilidad") }}</localized-link></li>
                                        <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/personas">{{ $t("nav.personas") }}</localized-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="item">
                        <img :src="`${publicPath}img/home02weAreWater.jpg`" alt='' class="foto3">
                        <div aria-labelledby="columna3" class="hover">
                            <div class="item__overlay">
                                <div class="itemHeader" id="columna3" aria-hidden="true">
                                    <div class="row headerHome">
                                        <div class="col-9 pe-0"><h3 class="text-white"><localized-link to="/fundacion-we-are-water"  v-html="$t('home.fundacion-we-are-water')"></localized-link></h3></div>
                                        <div class="col-3 text-end itemNumber">02</div>
                                    </div>
                                </div>
                                <div class="item__body">
                                    <ul class="navbar-nav">
                                        <li class="itemMenu"><localized-link to="/fundacion-we-are-water/proyectos-de-cooperacion">{{ $t("nav.proyectos-de-cooperacion") }}</localized-link></li>
                                        <li class="itemMenu"><localized-link to="/fundacion-we-are-water/acciones-de-concienciacion">{{ $t("nav.acciones-de-concienciacion") }}</localized-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="item">
                        <img :src="`${publicPath}img/home03informeFinanciero.jpg`" alt='' class="foto4">
                        <div aria-labelledby="columna4" class="hover">
                            <div class="item__overlay">
                                <div class="itemHeader" id="columna4" aria-hidden="true">
                                    <div class="row headerHome">
                                        <div class="col-9 pe-0"><h3 class="text-white"><localized-link to="/informe-financiero" v-html="$t('home.informe-financero')"></localized-link></h3></div>
                                        <div class="col-3 text-end itemNumber">03</div>
                                    </div>
                                </div>
                                <div class="item__body">
                                    <ul class="navbar-nav">
                                        <li class="itemMenu"><localized-link to="/informe-financiero">{{ $t("nav.informe-financero") }}</localized-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
    <!-- end MENU CENTRAL -->

    <!-- MENU VERSIÓ MÒBIL -->
    <section class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none">
            <div class="item">
                <div class="itemTxt headerHome" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling00" aria-controls="offcanvasScrolling00">
                    <div class="itemNumber"></div>
                    <h3 class="text-white">ROCA GROUP<br>2021</h3>

                </div>
                <img :src="`${publicPath}img/home00RocaGroup.jpg`" alt='' class="foto1">
            </div>
            <div class="item">
                <div class="itemTxt headerHome" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling01" aria-controls="offcanvasScrolling01">
                    <div class="itemNumber">01</div>
                    <h3 class="text-white" v-html="$t('future')"></h3>
                </div>
                <img :src="`${publicPath}img/home01avanzando.jpg`" alt='' class="foto2">
            </div>
            <div class="item">
                <div class="itemTxt headerHome" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling02" aria-controls="offcanvasScrolling02">
                    <div class="itemNumber">02</div>
                    <h3 class="text-white" v-html="$t('home.fundacion-we-are-water')"></h3>
                </div>
                <img :src="`${publicPath}img/home02weAreWater.jpg`" alt='' class="foto3">
            </div>
            <div class="item">
                <div class="itemTxt headerHome" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling03" aria-controls="offcanvasScrolling03">
                    <div class="itemNumber">03</div>
                    <h3 class="text-white" v-html="$t('home.informe-financero')"></h3>
                </div>
                <img :src="`${publicPath}img/home03informeFinanciero.jpg`" alt='' class="foto4">
            </div>
    </section>

    <!-- CAPES LATERALS MENU MÒBIL -->
    <!-- CAPA 00 -->
    <div class="offcanvas offcanvas-start" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling00" aria-labelledby="offcanvasScrollingLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasScrollingLabel"></h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <div class="item__body text-start">
                <div class="itemNumber" style="color: #022e46">.</div>
                <h3><localized-link to="/roca-group-2021">ROCA GROUP<br>2021</localized-link></h3>
                <p>&nbsp;</p>
                <ul class="navbar-nav">
                  <li class="itemMenu">
                    <localized-link to="/roca-group-2021/presentacion">{{ $t("nav.presentacion") }}</localized-link>
                  </li>
                    <li class="itemMenu">
                        <localized-link to="/roca-group-2021/2021-en-resumen">{{ $t("nav.resumen") }}</localized-link>
                    </li>
                  <li class="itemMenu">
                    <localized-link to="/roca-group-2021/roca-group-en-el-mundo">{{ $t("nav.en-el-mundo") }}</localized-link>
                  </li>

                    <li class="itemMenu text-end">
                        <a :href="`${publicPath}es/`" :class="isEs ? 'router-active-language' : ''">CAS</a> | <a :href="`${publicPath}en/`" :class="isEn ? 'router-active-language' : ''">ENG</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- end CAPA 00 -->

    <!-- CAPA 01 -->
    <div class="offcanvas offcanvas-start" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling01" aria-labelledby="offcanvasScrollingLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasScrollingLabel"></h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <div class="item__body text-start">
                <div class="itemNumber">01</div>
                <h3><localized-link to="/avanzando-hacia-el-futuro" v-html="$t('future')"></localized-link></h3>
                <p>&nbsp;</p>
                <ul class="navbar-nav">
                    <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/crecimiento">{{ $t("nav.crecimiento") }}</localized-link></li>
                    <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional">{{ $t("nav.excelencia-operacional") }}</localized-link></li>
                    <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/innovacion">{{ $t("nav.innovacion") }}</localized-link></li>
                    <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/transformacion-digital">{{ $t("nav.transformacion-digital") }}</localized-link></li>
                    <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/sostenibilidad">{{ $t("nav.sostenibilidad") }}</localized-link></li>
                    <li class="itemMenu"><localized-link to="/avanzando-hacia-el-futuro/personas">{{ $t("nav.personas") }}</localized-link></li>
                  <li class="itemMenu text-end">
                    <a :href="`${publicPath}es/`" :class="isEs ? 'router-active-language' : ''">CAS</a> | <a :href="`${publicPath}en/`" :class="isEn ? 'router-active-language' : ''">ENG</a>
                  </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- end CAPA 01 -->

    <!-- CAPA 02 -->
    <div class="offcanvas offcanvas-start" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling02" aria-labelledby="offcanvasScrollingLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasScrollingLabel"></h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <div class="item__body text-start">
                <div class="itemNumber">02</div>
                <h3><localized-link to="/fundacion-we-are-water" v-html="$t('home.fundacion-we-are-water')"></localized-link></h3>
                <p>&nbsp;</p>
                <ul class="navbar-nav">
                    <li class="itemMenu"><localized-link to="/fundacion-we-are-water/proyectos-de-cooperacion">{{ $t("nav.proyectos-de-cooperacion") }}</localized-link></li>
                    <li class="itemMenu"><localized-link to="/fundacion-we-are-water/acciones-de-concienciacion">{{ $t("nav.acciones-de-concienciacion") }}</localized-link></li>
                  <li class="itemMenu text-end">
                    <a :href="`${publicPath}es/`" :class="isEs ? 'router-active-language' : ''">CAS</a> | <a :href="`${publicPath}en/`" :class="isEn ? 'router-active-language' : ''">ENG</a>
                  </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- end CAPA 02 -->

    <!-- CAPA 03 -->
    <div class="offcanvas offcanvas-start" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling03" aria-labelledby="offcanvasScrollingLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasScrollingLabel"></h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <div class="item__body text-start">
                <div class="itemNumber">03</div>
                <h3><localized-link to="/informe-financiero" v-html="$t('home.informe-financero')"></localized-link></h3>
                <p>&nbsp;</p>
                <ul class="navbar-nav">
                    <li class="itemMenu"><localized-link to="/informe-financiero">{{ $t("nav.informe-financero") }}</localized-link>
                    </li>
                  <li class="itemMenu text-end">
                    <a :href="`${publicPath}es/`" :class="isEs ? 'router-active-language' : ''">CAS</a> | <a :href="`${publicPath}en/`" :class="isEn ? 'router-active-language' : ''">ENG</a>
                  </li>

                </ul>
            </div>
        </div>
    </div>
    <!-- end CAPA 03 -->

    <!-- end CAPES LATERALS MENU MÒBIL -->
    <!-- end MENU VERSIÓ MÒBIL -->
  <!-- <video-modal />  -->
</template>

<script>
//import VideoModal from '@/components/VideoModal.vue'
export default {
  name: "HomeView",
  components: {
     // VideoModal
  },
  data() {
      return {
          publicPath: process.env.BASE_URL,
          isEs: this.$i18n.locale=='es' ? true : false,
          isEn: this.$i18n.locale=='en' ? true : false,

      }
  }
};
</script>

